import React from "react";
import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";
import { useParams } from "react-router";
import { get } from "lodash-es";
import { Organization, isOrganization } from "services/BillingEngineService/interfaces/entities";

interface Props {
  organizationID: string;
  organizationRateCards?: Organization;
  status: "success" | "loading" | "error" | "idle";
}

const OrganizationRateCardContext = React.createContext<Props | undefined>(undefined);

const OrganizationRateCardProvider: React.FC = ({ children }) => {
  const params = useParams();
  const organizationID = get(params, "organization_id");

  const { data, status } = useQuery(["organization", organizationID], BillingEngineService.getOrganizationDetails, {
    refetchOnWindowFocus: false,
    retry: false,
  });

  return (
    <OrganizationRateCardContext.Provider
      value={{
        status,
        organizationRateCards: isOrganization(data) ? data : undefined,
        organizationID,
      }}
    >
      {children}
    </OrganizationRateCardContext.Provider>
  );
};

/**
 * Hook to get access to OrganizationRateCardProvider
 */
const useOrganizationRateCardContext = () => {
  const context = React.useContext(OrganizationRateCardContext);

  if (!context) {
    throw new Error("useOrganizationRateCardContext can be used only inside <OrganizationRateCardProvider />");
  }

  return context;
};

export { OrganizationRateCardProvider, useOrganizationRateCardContext };
